import { api } from 'mmfintech-backend-api'

const tkbFeeDiscountApi = (api as any).injectEndpoints({
  endpoints: (build: any) => ({
    updateTkbFeeDiscount: build.mutation({
      query: enabled => ({
        url: '/merchants/merchant/settings/tkb-fee-discount',
        method: 'PATCH',
        body: JSON.stringify(enabled),
        headers: { 'Content-Type': 'application/json' }
      }),
      onQueryStarted: async (enabled, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          api.util.updateQueryData('getMerchantSettings' as never, undefined as never, (draft: any) => {
            if (draft) draft.tkbFeeDiscountEnabled = enabled
          })
        )
        try {
          await queryFulfilled
        } catch {
          patch.undo()
        }
      },
      invalidatesTags: ['MerchantSettings'] as any
    })
  })
})

export const { useUpdateTkbFeeDiscountMutation } = tkbFeeDiscountApi
